import Ellipsing from 'components/Ellipsing/Ellipsing.component';
import { tagColors, TagContainer, TagIconContainer, TagIntent, TagTextContainer } from './styles';
import { useIntl, FormattedMessage } from 'react-intl';
import { SVGComponentPropsType } from 'assets/types';
import { FilterTab, ListFilters, ResultCount, TabLabel } from '../styles';

export const BaseTag = ({
  translationId,
  intent,
  icon: Icon,
}: {
  icon: React.ComponentType<SVGComponentPropsType>;
  translationId: string;
  intent: TagIntent;
}) => {
  const { formatMessage } = useIntl();
  return (
    <TagContainer intent={intent}>
      <TagIconContainer>
        <Icon color={tagColors[intent].color} size={22} />
      </TagIconContainer>
      <TagTextContainer>
        <Ellipsing text={formatMessage({ id: translationId })} />
      </TagTextContainer>
    </TagContainer>
  );
};

type TabInfo = {
  label: string;
  count: number;
  onClick: () => void;
  $selected: boolean;
  disabled?: boolean;
};

const Tab = ({ label, count, onClick, $selected, disabled = false }: TabInfo) => {
  return (
    <FilterTab
      onClick={onClick}
      $selected={$selected}
      // @ts-expect-error TS(2769): No overload matches this call.
      disabled={disabled}
    >
      <TabLabel>
        <ResultCount>{count}</ResultCount>
        <FormattedMessage id={label} />
      </TabLabel>
    </FilterTab>
  );
};

export const TableTabs = ({ tabs }: { tabs: Array<TabInfo> }) => {
  return (
    <ListFilters>
      {tabs.map((tab) => (
        <Tab key={tab.label} {...tab} />
      ))}
    </ListFilters>
  );
};
